 <mm-table
  *ngIf="usersData"
  [values]="usersData"
  [columnNames]="columnNames"
  [tableSize]="scrollSize"
  [thClass]="['size','size-m',null,null]"
  [tdClass]="['text-start', 'text-start']"
  (tdClick)="editTable($event)">
</mm-table>
